import { render, staticRenderFns } from "./AlertPreferencesRoute.vue?vue&type=template&id=073f2cfc&"
import script from "./AlertPreferencesRoute.vue?vue&type=script&lang=js&"
export * from "./AlertPreferencesRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports